<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_103_2198)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <path
    d="M28.7624 39.8086V38.9445L28.0132 39.3751L21.3212 43.2214L17.5849 36.7801L24.275 32.9335L25.0289 32.5L24.275 32.0666L17.5859 28.2205L21.3206 21.7783L28.0131 25.6263L28.7623 26.0571V25.1929V17.5H36.2365V25.1929V26.057L36.9857 25.6263L43.6797 21.7783L47.4158 28.2205L40.7253 32.0665L39.9713 32.5L40.7253 32.9335L47.4154 36.7801L43.6791 43.2228L36.9856 39.3751L36.2365 38.9444V39.8086V47.5H28.7624V39.8086ZM43.5663 21.5827L43.5666 21.5832L43.5663 21.5827ZM47.6144 28.1063L47.614 28.1066L47.6144 28.1063Z"
    fill="url(#paint1_linear_103_2198)"
    stroke="url(#paint2_linear_103_2198)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_103_2198"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_103_2198"
      x1="32.5"
      y1="17"
      x2="-6.06696"
      y2="32.0372"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_103_2198"
      x1="42.7574"
      y1="14.6154"
      x2="26.7543"
      y2="29.4294"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
